(function () {
    'use strict';
    Controllers.CoronaController = class CoronaController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $translate, $window, UsersManager, PopupMessageService, AnalyticsService,
                    EventsManager, WorkspacesManager, moment, ModalService, DeviceService, _, FeaturesService,
                    SchedulingService) {
            super($scope, $injector);
            this.__objectType = 'CoronaController';
            this.$translate = $translate;
            this.$window = $window;
            this.UsersManager = UsersManager;
            this.PopupMessageService = PopupMessageService;
            this.AnalyticsService = AnalyticsService;
            this.EventsManager = EventsManager;
            this.ModalService = ModalService;
            this.WorkspacesManager = WorkspacesManager;
            this.moment = moment;
            this.FeaturesService = FeaturesService;
            this.user = this.UsersManager.getCurrUser();
            this.company = this.user.company;
            this.SchedulingService = SchedulingService;
            this._ = _;
            this.PAGE_SIZE = 5;
            this.listSize = this.PAGE_SIZE;
            this.isLoading = true;

            if (DeviceService.checkIfMobileSize()) {
                this.goToState(this.AppStates.root_core_navigation_home);
            }

            this.AnalyticsService.trackPageView(this, this.AnalyticsService.analytics_events.corona_dashboard_page);

            this.maxValue = null;
            this.minValue = null;
            this.projectList = [];



            this.getProjectList();

            this.lawyerData = [
                {name: 'Christina Scalera', website: 'thecontractshop.com', email: 'christina@thecontractshop.com'},
                {name: 'Elle Danielle', website: 'elledanielle.com', email: 'legal@elledanielle.com'},
                {name: 'Paige Griffith', website: 'thelegalpaige.com', email: 'paige@thelegalpaige.com'},
                {name: 'Paige Hulse', website: 'paigehulse.com', email: 'hello@paigehulse.com'},
            ];

            this.newEmailTemplatesWaitingCount = '';
            this.newContractTemplatesWaitingCount = '';

            this.getNewEmailCount();
            this.getNewContractCount();
            this.initSessionTypes();
        }

        getPriorityTooltip() {
            let tooltip = 'COVID_DASHBOARD.TOOLTIPS._SCORE_WITH_GUESTS_';
            if (this.shouldHideGuests()) {
                tooltip = 'COVID_DASHBOARD.TOOLTIPS._SCORE_NO_GUESTS_';
            }

            return this.$translate.instant(tooltip);
        }

        shouldHideGuests() {
            return this.company.shouldHideProjectField('guests');
        }

        getProjectList() {
            let firstThreeWeeksProjects = [];
            let fiveWeeksAfterProjects = [];

            this.EventsManager.listCoronaRiskedProjects(true)
                .then(projects => {


                    projects.forEach(project => {
                        project.workspaces.forEach(workspace => {

                            const newProject = {
                                archived: project.hasArchivedWorkspace(),
                                event_name: project.event_name,
                                event_date: project.event_date,
                                event_guests: this.numberWithCommas(project.event_guests || 0),
                                guestsNumber: project.event_guests,
                                next_payment_date: project.next_payment_date,
                                next_payment_value: project.next_payment_value,
                                total_project_value: project.total_project_value,
                                workspaces: project.workspaces,
                                workspace: workspace,
                                _id: project._id,
                                workspaceID: workspace._id,
                                pipeline_stage: this.getStageName(workspace.pipeline_stage ? workspace.pipeline_stage.name : ''),
                                stage_category: workspace.pipeline_stage.category,
                                score: this.getProjectScore(project),
                                creator_id: project.creator_id,
                                members: this.getWorkspaceMembers(workspace, project.creator_id),
                                isActionMenuOpen: false
                            };

                            const dateToCompare = this.moment();

                            if (this.moment(project.event_date).isBefore(dateToCompare.add(3, 'w'))) {
                                firstThreeWeeksProjects.push(newProject);
                            } else if (this.moment(project.event_date).isBefore(dateToCompare.add(5, 'w'))){
                                fiveWeeksAfterProjects.push(newProject);
                            }
                        });
                    });


                    const sortedFirstThreeWeeksProjects = firstThreeWeeksProjects.sort(function (a, b) {
                        let dateA = new Date(a.event_date), dateB = new Date(b.event_date);
                        return dateA - dateB;
                    });

                    sortedFirstThreeWeeksProjects.forEach(project => {project.priority = 'high';});


                    const sortedFiveWeeksAfterProjects = fiveWeeksAfterProjects.sort(function (a, b) {
                        return b.score - a.score;
                    });

                    const range = (this.maxValue - this.minValue) / 3;
                    sortedFiveWeeksAfterProjects.forEach(project => {
                        if (project.score > (range * 2)) {
                            project.priority = 'high';
                        } else if ((project.score > range) && (project.score < (2 * range))) {
                            project.priority = 'medium';
                        } else {
                            project.priority = 'low';
                        }
                    });

                    this.projectList = [...sortedFirstThreeWeeksProjects, ...sortedFiveWeeksAfterProjects];

                    this.isLoading = false;
                });
        }

        getWorkspaceMembers(workspace, creator_id) {
            return workspace.members.filter(member => member._id !== creator_id);
        }

        shouldShowOpps() {
            return this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.coronaOpps)
        }

        initSessionTypes() {
            this.sessionTypes = [];
            if (this.SchedulingService.isSchedulingEnabled(this.user)) {
                this.user.getSessions(null, null, true).then(function (resp) {
                    this.sessionTypes = resp;
                }.bind(this));
            }
        }

        getProjectScore(project){
            const stageScore = project.pipeline_stage === 'Inquiry' ? 1 : (project.stage_category === 'booked' ? 3 : 2);
            const score = project.total_project_value * (project.guestsNumber || 1) * stageScore;

            if (this.maxValue === null) {
                this.maxValue = score;
                this.minValue = score;
            } else if (this.maxValue < score) {
                this.maxValue = score;
            } else if (this.minValue > score) {
                this.minValue = score;
            }

            return score;
        }

        confirmationPopup(resp) {

            var confirmMsg;
            var templateCount = 0;

            if (resp.data && resp.data.template_ids && Array.isArray(resp.data.template_ids)) {
                templateCount = resp.data.template_ids.length;
            }

            if (templateCount === 0) {
                confirmMsg = 'No new templates to import.';
            } else if (templateCount === 1) {
                confirmMsg = 'One new template was successfully added to your templates library.';
            } else {
                confirmMsg = templateCount + " new templates were successfully added to your templates library.";
            }

            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.success, confirmMsg, () => {
                this.goToState(this.AppStates.root_core_navigation_templates);
            }, 'Browse templates');
        }

        importCommunication() {
            this.UsersManager.coronaInjectClientCommunicationEmailTemplates().then(
                function ok(resp) {
                    this.confirmationPopup(resp);
                }.bind(this),

                function bad(resp) {
                }
            );
        }

        openChooseTemplateModal(params) {
            this.ModalService.openCoronaChooseTemplateModal(params);
        }

        getNewContractCount() {
            this.UsersManager.coronaGetContractTemplates().then(
                function ok(resp) {
                    if (resp.data && resp.data.template_ids && Array.isArray(resp.data.template_ids)) {
                        this.newContractTemplatesWaitingCount = "(" + resp.data.template_ids.length + " NEW)";
                    }
                }.bind(this),

                function bad(resp) {
                }
            );
        }

        getNewEmailCount() {
            this.UsersManager.coronaGetClientCommunicationEmailTemplates().then(
                function ok(resp) {
                    if (resp.data && resp.data.template_ids && Array.isArray(resp.data.template_ids)) {
                        this.newEmailTemplatesWaitingCount = "(" + resp.data.template_ids.length + " NEW)";
                    }
                }.bind(this),

                function bad(resp) {
                }
            );
        }

        importContract() {
            this.UsersManager.coronaInjectContractTemplates().then(
                function ok(resp) {
                    this.confirmationPopup(resp);
                }.bind(this),

                function bad(resp) {
                }
            );
        }

        gotoGiftCards() {
            this.goToState(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'giftCard'});
        }

        clickShowMore() {
            this.listSize += this.PAGE_SIZE;
        }

        numberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        shouldSeeGiftCard() {
            return this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.instantBookingGiftCards) && this.user.isCompanyOwner();
        }

        getStageName(name) {
            const stageName = this.$translate.instant("PIPELINE.STAGES." + name);
            if (stageName === "PIPELINE.STAGES." + name) {
                return name;
            }

            return stageName;
        }

        onArchiveDone(){
            this.ToastService.showSuccess({
                contentTranslation: "PIPELINE.TOASTS._ARCHIVE_",
                iconCssClass: 'icon icon-hb-nx-check-mark-circle-16',
                dismissOnTimeout: true,
                dismissButton: true,
                timeout: 5000
            });

            this.getProjectList();
        }
    };
}());
